var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.submissions)?_c('Multiviewer',{attrs:{"data":_vm.submissions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }